import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Subject } from 'rxjs'
import { FindRulesForm } from '../models/find-rules.model'

@Component({
  selector: 'hs-find-rules-popover',
  templateUrl: './find-rules-popover.component.html',
  styleUrls: ['./find-rules-popover.component.scss'],
})
export class FindRulesPopoverComponent {
  private readonly _destroyed$ = new Subject<void>()

  isFormSubmitting = false
  applyDisabled = false
  accountIds: number[] = []
  ids: string[] = []

  readonly rootIdType = new FormControl('account', [Validators.required])
  readonly rootIds = new FormControl('', [Validators.required])
  @Output() find = new EventEmitter<FindRulesForm>()

  form = new FormGroup({
    rootIdType: this.rootIdType,
    rootIds: this.rootIds,
  })

  @Input() set focusedIds(accountIds: number[] | null) {
    if (accountIds && (accountIds?.length ?? -1) > 0) {
      this.rootIds.setValue(accountIds.join(','))
      this.rootIdType.setValue('account')
      this.find.emit({
        rootIdType: 'account',
        rootIds: accountIds.join(','),
      })
    }
  }

  onSubmit() {
    this.find.emit({
      rootIdType: this.rootIdType.value,
      rootIds: this.rootIds.value,
    })
  }

  resetForm() {
    this.form.reset()
  }
}
